import { useState } from 'react';

import { BehavioralInsightPresentationMode, EventTypes } from 'modules/domains/segmentation';
import { getKeyByValue } from '@iterable/utils';
import { SelectValueType } from 'ui/selects';
import { ITERABLE_EVENTS, HUMAN_READABLE_ITERABLE_EVENTS } from 'constants/eventTypes';
import {
  BEHAVIORAL_EVENT_SELECT_SEGMENTED_OPTIONS,
  BEHAVIORAL_EVENT_SELECT_WIDTH,
} from 'modules/segmentation/constants';
import { InsightSelect } from '../insightSelect/InsightSelect';
import { useCustomBehavioralContext } from '../../../contexts/behaviorInsights/customBehavior';
import { useTranslation } from '../../../hooks';
import { getBehavioralEventLabel, getBehavioralEventSelectOptions } from '../../../utils';

export const testIds = {
  select: 'behavioral-event-select',
  toggle: 'behavioral-event-toggle',
};

export const BehavioralEventSelect = () => {
  const { t } = useTranslation();
  const {
    addCustomBehavioralEvent,
    selectableEventsForProject,
    cachedCustomBehavioralInsights,
    maxBehavioralInsightSettingsForProject,
  } = useCustomBehavioralContext();
  /** we want TotalCount to be the default */
  const [isTotalCount, updateMode] = useState<boolean>(true);
  const presentationMode = isTotalCount
    ? BehavioralInsightPresentationMode.TotalCount
    : BehavioralInsightPresentationMode.Rate;
  const toggleMode = (mode: BehavioralInsightPresentationMode) => {
    if (mode !== presentationMode) {
      updateMode((previous) => !previous);
    }
  };

  const isMaxPropertiesSelected =
    !!cachedCustomBehavioralInsights &&
    cachedCustomBehavioralInsights.length === maxBehavioralInsightSettingsForProject;

  const selectOptions = getBehavioralEventSelectOptions(selectableEventsForProject);

  const handleOptionSelect = ([value]: SelectValueType[]) => {
    const event = `${value}`;
    const dataType = getKeyByValue(ITERABLE_EVENTS, event, EventTypes.CustomEvent);
    const eventName = getBehavioralEventLabel(dataType, HUMAN_READABLE_ITERABLE_EVENTS, event);
    addCustomBehavioralEvent(eventName, presentationMode, dataType);
  };

  return (
    <InsightSelect
      isDisabled={isMaxPropertiesSelected}
      selectTestId={testIds.select}
      selectPlaceholder={t('insights.select.behavioralEventPlaceholder')}
      selectOptions={selectOptions}
      onOptionSelect={handleOptionSelect}
      segmentedControlTestId={testIds.toggle}
      segmentedControlMode={presentationMode}
      segmentedControlOptions={BEHAVIORAL_EVENT_SELECT_SEGMENTED_OPTIONS}
      onSegmentedControlSelect={toggleMode}
      textInputPlaceholder={t('insights.select.filterPlaceholder')}
      width={BEHAVIORAL_EVENT_SELECT_WIDTH}
    />
  );
};
